module.exports = __webpack_public_path__ + "static/img/cleanser-01.20921ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/cleanser-01.jpg
// module id = 255
// module chunks = 1